import { GraphQLClient } from "graphql-request";

import { API_SERVICE_URL } from "#shared/consts";

export const gqlClient = new GraphQLClient(`${API_SERVICE_URL}/query`);
